import React from "react";

function TabOverview() {
  return <div>Amazon overview text...</div>;
}

export default TabOverview;
